import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class ActiveInstructorsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/activeInstructors";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getInstructorById(userId, router) {
    const url = `/api/activeInstructors/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getInstructorByUserId(userId, router) {
    const url = `/api/activeInstructors/user/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  getDocumentsByUserId(userId, router) {
    const url = `/api/activeInstructors/documents/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  create(formData) {
    const url = "/api/activeInstructors";
    return this.CommonAPIService.newFileCall(url, formData);
  }

  update(id, formData) {
    const url = `/api/activeInstructors/${id}`;
    return this.CommonAPIService.newFileCall(url, formData);
  }

  delete(userId, router) {
    const url = `/api/activeInstructors/${userId}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getInstructorRoles(router) {
    const url = "/api/activeInstructors/instructorRoles";
    return this.CommonAPIService.getCall(url, "", router);
  }
}
export default ActiveInstructorsAPIService;
